import Model from './utils/model'
import nexus from '@db2b/nexus-js'

export default {
  ...Model,
  options: {
    translations: {
      name: 'Email'
    },
    name: 'email',
    url: nexus.url('notification', 'emails')
  }
}



// WEBPACK FOOTER //
// ./libs/@db2b/keystone/model/email.js